import { IosSilentHack } from "../audio/IosSilentHack.js";
import { Home } from "../display/Home.js";
import { Stage } from "../display/Stage.js";
import { Idle } from "../model/Idle.js";

export interface TestAppOptions {
    element: HTMLDivElement;
    assetsUrl: string;
}

export class MainApp {

    private _element: HTMLDivElement;
    private _options: TestAppOptions;

    private _stage: Stage;
    private _audioContext: AudioContext;
    private _home: Home;

    constructor(options: TestAppOptions) {

        this._options = options;
        this._element = options.element;

        this.init();
    }

    private async init() {
        try {
            new IosSilentHack();

            this._stage = new Stage({
                element: this._element,
                assetsUrl: this._options.assetsUrl
            });

            new Promise((resolve) => {
                document.addEventListener("click", () => {
                    Tone.start();
                    resolve(true);
                }, { once: true });
            });

            this._audioContext = (Tone.context as any).rawContext;
            Tone.Transport.bpm.value = 120;
            Tone.Transport.start();
            Tone.Master.volume.value = Tone.gainToDb(0.5);

            this._home = await new Home().create({
                container: this._stage.content,
                audioContext: this._audioContext,
                assetsUrl: this._options.assetsUrl,
                dataUrl: this._element.getAttribute("data-data"),
            });

            const idle = new Idle({
                duration: 5 * 60 * 1000,//5 minutes in MS
                onIdle: () => {
                    this.setIdle()
                }
            });

        } catch (error) {
            var err = error as Error;
            console.error(error);
            this._stage.preloader.showError(err?.message || "Es ist ein Unbekannter Fehler aufgetreten.");
            return;
        }

        this._stage.preloader.hide();
    }

    private setIdle(): void {

    }
}